import { DownOutlined } from "@ant-design/icons";

import { BreadCrumbItem } from "../bread-crumb-item";
import { BreadCrumbItemProps, MenuItem } from "../types";

import { SelectMenuPopover } from "./select-menu-popover";

interface BreadCrumbSelectItemProps extends BreadCrumbItemProps {
	menuList: MenuItem[];
	popoverWidth?: number;
}

export const BreadCrumbSelectItem = ({
	route,
	paths,
	menuList,
	popoverWidth,
}: BreadCrumbSelectItemProps) => (
	<SelectMenuPopover menuList={menuList} popoverWidth={popoverWidth}>
		<span className="flex items-center gap-4">
			<BreadCrumbItem route={route} paths={paths} />

			<DownOutlined className="size-12 pt-1" />
		</span>
	</SelectMenuPopover>
);
